import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Only superadmins may enter. Not-logged-in → /login.
 * Authenticated non-superadmins → /chat (the main app dashboard),
 * rather than the /403 page, per the onboarding spec.
 */
export default function SuperadminRoute({ children }) {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user") || "null");
  } catch {}

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "superadmin") return <Navigate to="/chat" replace />;
  return children;
}
